import { useState, useEffect } from "react";
import { Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

function PaginationSearch({
  pagination,
  currentPage,
  setCurrentPage,
  limit,
  setLimit,
}) {
  const [searchPage, setSearchPage] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [message, setMessage] = useState("");

  // 🔥 debounce untuk ketik manual
  useEffect(() => {
    if (!searchPage || searchPage < 1 || searchPage > pagination.totalPages)
      return;
    if (!isTyping) return;

    const delayDebounce = setTimeout(() => {
      setCurrentPage(Number(searchPage));
      setIsTyping(false);
    }, 500); // debounce 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchPage, isTyping, setCurrentPage, pagination.totalPages]);

  // Format tampilan untuk pesan
  useEffect(() => {
    if ( pagination.total) {
      setMessage(`Menampilkan ${pagination.from} - ${pagination.to} dari ${pagination.total} data`);
    } else {
      setMessage(`Menampilkan 0 data`);
    }
  }, [pagination.total, pagination.from, pagination.to]);

  // handle input halaman
  const handleChange = (e) => {
    let val = parseInt(e.target.value);

    if (isNaN(val)) {
      setSearchPage("");
    } else if (val < 1) {
      setSearchPage(1);
    } else if (val > pagination.totalPages) {
      setSearchPage(pagination.totalPages);
    } else {
      setSearchPage(val);
    }

    setIsTyping(true);
  };

  return (
    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2">
      {/* info jumlah data */}
      <div>
        {message}
        {/* Menampilkan `{pagination.total? 
        `${pagination.form} - ${pagination.to} dari ${pagination.total}` : `0 dari 0`}
        data */}
      </div>

      {/* Input search page */}
 

      {/* Input limit per halaman */}
      <div className="align-items-center group-this-items ms-3 gap-2 d-flex flex-row">
        <div>Jumlah Baris</div>
        <Form.Select
          value={limit}
          style={{ height: "2rem" }}
          onChange={(e) => {
            let val = parseInt(e.target.value);
            setLimit(val);
            setCurrentPage(1); // reset ke halaman pertama
          }}
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="250">250</option>
          <option value="500">500</option>
        </Form.Select>
      </div>

      {/* Tombol navigasi halaman */}
      <div className="group-this-items ms-3">
        <OverlayTrigger placement="top" overlay={<Tooltip>Awal</Tooltip>}>
          <Button
            variant="none border-0"
            size="sm"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}
            className="me-2"
          >
            <i className="fas fa-fast-backward"></i>
          </Button>
        </OverlayTrigger>

        <OverlayTrigger placement="top" overlay={<Tooltip>Sebelumnya</Tooltip>}>
          <Button
            variant="none border-0"
            size="sm"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            className="me-2"
          >
            <i className="fas fa-step-backward"></i>
          </Button>
        </OverlayTrigger>

        <Form.Control
          type="number"
          placeholder="Hal..."
          value={currentPage}
          onChange={handleChange}
          style={{ textAlign: "center", height: "2rem" }}
          min={1}
          max={pagination.totalPages}
          disabled={pagination.totalPages <= 1}
        />

        <OverlayTrigger placement="top" overlay={<Tooltip>Selanjutnya</Tooltip>}>
          <Button
            variant="none border-0"
            size="sm"
            disabled={currentPage >= pagination.totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            className="me-2"
          >
            <i className="fas fa-step-forward"></i>
          </Button>
        </OverlayTrigger>

        <OverlayTrigger placement="top" overlay={<Tooltip>Akhir</Tooltip>}>
          <Button
            variant="none border-0"
            size="sm"
            disabled={currentPage >= pagination.totalPages}
            onClick={() => setCurrentPage(pagination.totalPages)}
          >
            <i className="fas fa-fast-forward"></i>
          </Button>
        </OverlayTrigger>
      </div>
    </div>
  );
}

export default PaginationSearch;
